import { createUseStyles } from "react-jss";
import { BP } from "utils/ui/breakpoints";

const styles = {
  app: {
    alignItems: "flex-start",
    background: "linear-gradient(155.14deg, rgba(255, 255, 255, 0.15) 0.68%, rgba(255, 255, 255, 0) 38.68%)",
    backgroundColor: "var(--sidebar)",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minWidth: `${BP.TEN}px`,
    width: "100%",
  },
};

export const useStyles = createUseStyles(styles);
